import { ElementGroup } from './elementGroup';
import { EquipmentElements } from './equipmentElements';

interface IEquipmentElement {
	icon: string; // icon name for display on side panel
	name: string; // translate key
	type: EquipmentElements; // type for drag & drop
	group: ElementGroup; // назва групи елементу
	behavior: 'auto' | 'custom'; // тип виставлення (автоматична привязка до елементів чи кастомна)
	deniedRepresentations: Array<'front' | 'top'>; // заборонені вигляди для вкидання
	allowedTypes: Array<EquipmentElements>; // доступні для вкидання на них
	deniedTypes: Array<EquipmentElements>; // заборонені для вкиданя їх
	requiredTypes: Array<Array<EquipmentElements>>; // необхідні типи
	visible: boolean;
	canDrop?: boolean; // чи можна викласти елемент обладнання
	disabledHint?: string; // підказка, чому не можна викласти
}

export class EquipmentElement implements IEquipmentElement {
	icon: string;
	name: string;
	type: EquipmentElements;
	group: ElementGroup;
	behavior: 'auto' | 'custom';
	deniedRepresentations: Array<'front' | 'top'>;
	allowedTypes: Array<EquipmentElements>;
	deniedTypes: Array<EquipmentElements>;
	requiredTypes: Array<Array<EquipmentElements>>;
	visible: boolean;
	canDrop: boolean = false;
	disabledHint: string = '';

	constructor(params: IEquipmentElement) {
		this.icon = params.icon;
		this.name = params.name;
		this.type = params.type;
		this.group = params.group;
		this.behavior = params.behavior;
		this.visible = params.visible;
		this.allowedTypes = params.allowedTypes;
		this.requiredTypes = params.requiredTypes;
		this.deniedTypes = params.deniedTypes;
		this.deniedRepresentations = params.deniedRepresentations;
	}

	is(...types: Array<EquipmentElements>): boolean {
		return types.includes(this.type);
	}
}